import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        estimateId: Number
    }

    connect() {
        // find the form by its known id
        this.form = this.element.querySelector(`#move_form_${this.estimateIdValue}`)
        if (!this.form) return

        this.boundInjectHidden = this.injectHidden.bind(this)
        this.form.addEventListener("submit", this.boundInjectHidden)
    }

    disconnect() {
        if (!this.form || !this.boundInjectHidden) return
        this.form.removeEventListener("submit", this.boundInjectHidden)
        this.boundInjectHidden = null
    }

    injectHidden(e) {
        // remove any old hidden fields
        this.form.querySelectorAll("input[name='selected_item_ids[]']")
            .forEach(n => n.remove())

        // find checked checkboxes in this panel
        this.element.querySelectorAll(".estimate_item_checkbox:checked")
            .forEach(cb => {
                const hidden = document.createElement("input")
                hidden.type  = "hidden"
                hidden.name  = "selected_item_ids[]"
                hidden.value = cb.dataset.estimateItemId
                this.form.appendChild(hidden)
            })

        // if none, block submission
        if (this.form.querySelectorAll("input[name='selected_item_ids[]']").length === 0) {
            e.preventDefault()
            alert("Please select at least one item to move.")
        }
    }
}
